import { H3 } from '@h3/types';
import { request } from '@h3/request';
import * as Api from './constant';

/** 消息发送方 */
export const getSendUser = (data: {
    sendSideType: H3.Plugin.WxworkUserType;
    keyword: string;
    limit: number;
    cursor: string;
}) => {
    return request<
        H3.Http.Response.H3Response<{
            dataList: H3.Plugin.WxworkChatSendUser[];
            nextCursor: string;
            hasMore: boolean;
        }>
    >(Api.sendsides, {
        method: H3.Http.MethodType.POST,
        data,
    });
};

/** 消息接受方 */
export const getReceivedUser = (data: {
    sendSideType: H3.Plugin.WxworkUserType;
    sendSideId: string;
    receiveSideType: H3.Plugin.WxworkUserType;
    keyword: string;
    limit: number;
    cursor: string;
}) => {
    return request<
        H3.Http.Response.H3Response<{
            dataList: H3.Plugin.WxworkChatReceivedUser[];
            nextCursor: string;
            hasMore: boolean;
        }>
    >(Api.receivesides, {
        method: H3.Http.MethodType.POST,
        data,
    });
};

/** 消息接受方 */
export const getChatrecord = (data: {
    sendSideType: H3.Plugin.WxworkUserType;
    sendSideId: string;
    receiveSideType: H3.Plugin.WxworkUserType;
    receiveSideId: string;
    msgTypeList: H3.Plugin.WxworkchatType[];
    startTime: string;
    endTime: string;
    keyword: string;
    limit: number;
    cursor: string;
}) => {
    return request<
        H3.Http.Response.H3Response<{
            dataList: H3.Plugin.WxworkChatMessage[];
            nextCursor: string;
            hasMore: boolean;
        }>
    >(Api.chatrecord, {
        method: H3.Http.MethodType.POST,
        data,
    });
};

export const asyncChatrecord = () => {
    return request<H3.Http.Response.H3Response<void>>(Api.asyncChatrecord, {
        method: H3.Http.MethodType.POST,
    });
};
